import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import 'rxjs/add/observable/of';
import { Utility } from '../../common/utility';
import { BaseService } from '../../shared/services/base.service';
import { DialogService } from '../../shared/services/dialog.service';
import { FormGroup, FormBuilder, Validators, FormControl, AbstractControl } from '@angular/forms';
import { ReportService, formReport, controlNameList, reportTypePermission, visibleFields } from './report.service';
import {
  ReportType, CentreReport, DestinationReport,
  DestinationsReport, GenderReport, GroupReport
} from '../../models/report/report.model';
import * as moment from 'moment';
import { ValidationService } from '../../shared/services/validation.service';
import { SharedService } from '../../shared/services/share.services';
import { AppConstants } from '../../shared/constants/constants';
import { CompanyAccountService } from '../centre/manage-company-accounts/company-account.service';
import { AppMessages } from '../../shared/constants/messages';
import { IfObservable } from 'rxjs/observable/IfObservable';
@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  providers: [ReportService, ValidationService, SharedService, CompanyAccountService],
  styles: [
    `.form-label{
      width: auto;
    }
      `,
    `.text-right{
        text-align: right;
      }
      `,
    `.text-left{
        text-align: left;
      }`
  ]
})

export class ReportComponent implements OnInit {
  reportForm: FormGroup;
  rpTypeConst = AppConstants.reportType;
  public rpTypePermission: any = reportTypePermission;
  public formRP = formReport;
  public ctrlNameList = controlNameList;
  public viFields = visibleFields;
  reportTypeList = new Array<ReportType>();
  centreList = new Array<CentreReport>();
  destination = new Array<DestinationReport>();
  destinations = new Array<DestinationsReport>();
  gender = new Array<GenderReport>();
  group = new Array<GroupReport>();
  currencies = new Array<any>();
  ageGroup = new Array<any>();
  occupations = new Array<any>();
  organisation = new Array<any>();
  vaccine = new Array<any>();
  practitioners = new Array<any>();
  productCategories = new Array<any>();
  types = [{ id: 0, name: 'Organisation' }, { id: 1, name: 'Patient REF' }];
  private reportTokenId: string;
  constructor(public utility: Utility,
    public baseService: BaseService,
    public dialogService: DialogService,
    public fb: FormBuilder,
    public shareServices: SharedService,
    private companyAccountService: CompanyAccountService,
    public rpService: ReportService) {
    this.createForm();
    Object.keys(this.viFields).map((key, index) => {
      this.viFields[key] = false;
    });
    this.reportForm.controls.destination.valueChanges.subscribe(value => {
      if (value) {
        const val = parseInt(value, 0);
        if (this.destination.length > 0) {
          if (this.destination.find(x => parseInt(x.id, 0) === val).name.toLowerCase() === 'select') {
            this.viFields.destinations = true;
          } else {
            this.viFields.destinations = false;
          }
        }
      }
    });

    this.reportForm.controls.type.valueChanges.subscribe(value => {
      if (value) {
        if (parseInt(value, 0) === 0) {
          this.viFields.organisation = true;
          this.viFields.patientRef = false;
          this.reportForm.controls.organisation.setValidators([this.requireValidation]);
          this.reportForm.controls.patientRef.setValidators(null);
        } else {
          this.viFields.organisation = false;
          this.viFields.patientRef = true;
          this.reportForm.controls.organisation.setValidators(null);
          this.reportForm.controls.patientRef.setValidators([Validators.required]);
        }
      }
    });
  }

  ngOnInit() {
    this.getReport();
    this.getCentre();
    this.getVaccine();
    this.getGender();
    this.getOrganisation();
    this.getGroup();
    this.getAgeGroup();
    this.getDestination();
    this.getDestinations();
    this.getOccupation();
    this.getCurrencies();
    this.getPractitioner();
    this.getProductCategories();
    this.reportTokenId = this.utility.randomKey();
  }

  getOrganisation() {
    this.companyAccountService.getCompanyAccountDropList(true).subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          if (data) {
            this.organisation = data;
          }
        }
      }
    );
  }

  getReport() {
    this.rpService.getReport().subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          if (data) {
            this.reportTypeList = data;
          }
        }
      }
    );
  }

  getCentre() {
    this.rpService.getCentre().subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          if (data) {
            this.centreList = data;
            this.centreList.unshift(new CentreReport('-1', 'All Centres', false));
            this.reportForm.controls.centre.setValue(this.centreList[0]);
          }
        }
      }
    );
  }

  getVaccine() {
    this.rpService.getVaccine().subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          if (data) {
            this.vaccine = data;
            this.vaccine.unshift({ id: null, name: 'All Vaccines' });
            this.reportForm.controls.vaccine.setValue(this.vaccine[0]);
          }
        }
      }
    );
  }

  getGroup() {
    this.rpService.getGroup().subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          if (data) {
            this.group = data;
            this.reportForm.controls.group.setValue(this.group.find(x => x.name.toLowerCase() === 'total').id);
          }
        }
      }
    );
  }

  getAgeGroup() {
    this.rpService.getAgeGroup().subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          if (data) {
            this.ageGroup = data;
            this.reportForm.controls.ageGroup.setValue(this.ageGroup.find(x => x.id === 1).id);
          }
        }
      }
    );
  }

  getGender() {
    this.rpService.getGender().subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          if (data) {
            this.gender = data;
          }
        }
      }
    );
  }

  getDestination() {
    this.rpService.getDestination().subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          if (data) {
            this.destination = data;
            this.reportForm.controls.destination.setValue(this.destination[0].id);
          }
        }
      }
    );
  }

  getDestinations() {
    this.rpService.getCountry().subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          if (data) {
            this.destinations = data;
          }
        }
      }
    );
  }

  getOccupation() {
    this.rpService.getOccupation().subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          if (data) {
            this.occupations = data;
            this.occupations.unshift({ id: null, name: 'All Occupations' });
            this.reportForm.controls.occupations.setValue(this.occupations[0]);
          }
        }
      }
    );
  }

  getCurrencies() {
    this.rpService.getCurrencies().subscribe(result => {
      if (result) {
        const data = result.json();
        if (data) {
          this.currencies = data;
          this.reportForm.controls['currency'].setValue(data[0].from);
        }
      }
    });
  }
  getPractitioner() {
    this.rpService.getPractitioner().subscribe(result => {
      if (result) {
        const data = result.json();
        if (data) {
          this.practitioners = data;
        }
      }
    });
  }
  getProductCategories() {
    this.rpService.getProductCategories().subscribe(result => {
      if (result) {
        const data = result.json();
        if (data) {
          this.productCategories = data;
        }
      }
    });
  }

  createForm() {
    this.reportForm = this.fb.group({
      reportType: ['', [Validators.required]],
      centre: [''],
      startDate: [new Date()],
      endDate: [],
      currency: [''],
      gender: [''],
      group: [''],
      ageGroup: [''],
      destination: [''],
      destinations: [''],
      occupations: [''],
      type: [],
      organisation: ['', this.requireValidation],
      patientRef: [''],
      bactchNo: [''],
      productCategories: [''],
      includeVaccineIncome: [true],
      includeConsultationIncome: [true],
      practitioners: [''],
      vaccine: ['']
    });

  }

  requireValidation(formCtrl: AbstractControl) {
    if (formCtrl.value) {
      if (formCtrl.value.id === '-1') {
        return { 'required': true };
      }
    }
    return null;
  }

  setHiddenDestinations() {
    this.viFields.destinations = !this.viFields.destinations;
  }

  changeReportType(event) {
    if (event) {     
      this.formChange(event.target.value);
    }
  }

  formChange(value) {    
    if (value) {      
      const tempName = this.reportTypeList.find(x => x.id === value).id;
      if(tempName != 'EOD')
      {
        this.reportForm.controls.startDate.setValue(null);
        this.reportForm.controls.endDate.setValue(null);
      }
      if (tempName.toLowerCase() !== this.rpTypeConst.TopDestinations.id) {
        this.reportForm.controls.destination.setValue(this.destination.find(x => x.name.toLowerCase() === 'top 10').id);
      }
      const organisationIndex = this.organisation.findIndex(x => x.id === null || x.id === '-1');
      if (organisationIndex > -1) {
        this.organisation.splice(organisationIndex, 1);
      }
      if (tempName.toLowerCase() !== this.rpTypeConst.PaymentsReceived.id &&
        tempName.toLowerCase() !== this.rpTypeConst.EmployeeVaccination.id) {
        this.reportForm.controls.type.setValue('');
        if (
          tempName.toLowerCase() === this.rpTypeConst.WithholdingTax.id || tempName.toLowerCase() === this.rpTypeConst.CompanySales.id) {
          this.organisation.unshift({ id: null, name: 'All Organisations' });
        } else {
          if (tempName.toLowerCase() === this.rpTypeConst.Statement.id) {
            this.organisation.unshift({ id: null, name: 'Select Organisations' });
          } else {
            this.organisation.unshift({ id: '-1', name: 'Select Organisations' });
          }
        }
      } else {
        this.reportForm.controls.type.setValue(this.types[1].id);
        this.organisation.unshift({ id: '-1', name: 'Select Organisations' });
      }
      this.reportForm.controls.organisation.setValue(this.organisation[0]);
      if (this.rpTypePermission[tempName]) {
        this.setValidationField(this.rpTypePermission[tempName]);
      } else {
        this.setValidationField([]);
      }
    } else {
      this.setValidationField([]);
    }
  }

  onStartDateInput(event) {
    // remove required if the input date is invalid
    ValidationService.removeRequiredError(this.reportForm.controls['startDate'], event);

  }

  onStartDateChange(event) {
    // ValidationService.validationDate(this.reportForm.controls['startDate'], event);
    this.validateDateRange(this.reportForm.controls['startDate'],
      this.reportForm.controls['endDate'], true);
  }

  onEndDateInput(event) {
    // remove required if the input date is invalid
    ValidationService.removeRequiredError(this.reportForm.controls['endDate'], event);
  }

  onEndDateChange(event) {
    // ValidationService.validationDate(this.reportForm.controls['endDate'], event);
    this.validateDateRange(this.reportForm.controls['startDate'],
      this.reportForm.controls['endDate'], false);
  }

  validateDateRange(fromDateControl: AbstractControl, toDateControl: AbstractControl, isFromDateActive) {
    if (ValidationService.isValidDate(fromDateControl) || ValidationService.isValidDate(toDateControl)) {
      return;
    }
    if (moment(fromDateControl.value).toDate() > moment(toDateControl.value).toDate()) {
      if (isFromDateActive) {
        fromDateControl.setErrors({ 'invailidStartDate': true });
      } else {
        toDateControl.setErrors({ 'invailidStartDate': true });
      }
    } else {
      fromDateControl.setErrors(null);
      toDateControl.setErrors(null);
    }
  }

  setValidationField(rpTypeArr: Array<string>) {
    if (rpTypeArr.length) {
      this.ctrlNameList.forEach(x => {
        this.viFields[x] = false;
        if (this.reportForm.get(x)) {
          this.reportForm.controls[x].setValidators(null);
          let i = 0;
          while (i < rpTypeArr.length) {
            if (x === rpTypeArr[i]) {
              this.viFields[x] = true;
              if (x === this.formRP.startDate.key || x === this.formRP.ageGroup.key ||
                x === this.formRP.group.key || x === this.formRP.destination.key ||
                x === this.formRP.occupations.key || x === this.formRP.vaccine.key) {
                this.reportForm.controls[x].setValidators([Validators.required]);
              }

              if (x === this.formRP.organisation.key) {
                if (this.reportForm.controls.reportType.value.toLowerCase() === this.rpTypeConst.PaymentsReceived.id ||
                  this.reportForm.controls.reportType.value.toLowerCase() === this.rpTypeConst.EmployeeVaccination.id) {
                  if (this.viFields.patientRef === false) {
                    this.reportForm.controls[x].setValidators([this.requireValidation]);
                  } else {
                    this.viFields[x] = false;
                  }
                } else {
                  this.reportForm.controls[x].setValidators([this.requireValidation]);
                }
              }
              if ((this.reportForm.controls.reportType.value.toLowerCase() === this.rpTypeConst.Debtors.id ||
                this.reportForm.controls.reportType.value.toLowerCase() === this.rpTypeConst.DebtorsGroupedByCentre.id ||
                this.reportForm.controls.reportType.value.toLowerCase() === this.rpTypeConst.Statement.id) &&
                x === this.formRP.startDate.key)
                 {
                this.reportForm.controls[x].setValidators(null);
              }
              // if (this.reportForm.controls.reportType.value.toLowerCase() === this.rpTypeConst.EmployeeVaccination.id) {
              //   if (x === this.formRP.patientRef.key) {
              //     this.reportForm.controls[x].setValidators([Validators.required]);
              //   }
              // }
              break;
            }
            i++;
          }
          this.reportForm.controls[x].updateValueAndValidity();
        }
      });
    } else {
      this.ctrlNameList.forEach(x => {
        if (this.reportForm.get(x)) {
          this.viFields[x] = false;
          this.reportForm.controls[x].setValidators(null);
          this.reportForm.controls[x].updateValueAndValidity();
        }
      });
    }
  }

  markAsTouch() {
    for (const key in this.reportForm.controls) {
      if (this.reportForm.controls.hasOwnProperty(key)) {
        this.reportForm.controls[key].markAsTouched();
        this.reportForm.controls[key].updateValueAndValidity();
      }
    }
  }

  submit() {
    this.markAsTouch();
    if (this.reportForm.valid) {
      const str = <string>this.reportForm.controls.endDate.value;
      if (!str) {
        //this.reportForm.controls.endDate.setValue(new Date());

        const tempEndDate = new  Date();
        tempEndDate.setFullYear(tempEndDate.getFullYear()+1);
        this.reportForm.controls.endDate.setValue(tempEndDate);
      }
      // this.markAsTouch();
      if (this.reportForm.valid) {
        // call api show report
        const rpTemp = this.reportForm.controls.reportType.value.toLowerCase();
        if (rpTemp === this.rpTypeConst.AssociateClinic.id ||
          rpTemp === this.rpTypeConst.VaccinePriceList.id) {
          const index = this.reportTypeList.findIndex(x => x.id === this.reportForm.controls.reportType.value);
          if (this.reportForm.controls.centre.value.isGroup) {
            this.dialogService.openErrorDialog({
              message: Utility.stringFormat(AppMessages.report.onlyCentre,
                [this.reportTypeList[index].name])
            });
            return;
          } else if (this.reportForm.controls.centre.value.id === '-1') {
            this.dialogService.openErrorDialog({
              message: Utility.stringFormat(AppMessages.report.onlyCentre,
                [this.reportTypeList[index].name])
            });
            return;
          }
        }
        let params = {};
        const fromDate = this.reportForm.controls.startDate.value ?
          this.utility.convertDateToString(new Date(this.reportForm.controls.startDate.value)) : null;
        const toDate = this.utility.convertDateToString(new Date(this.reportForm.controls.endDate.value));
        const tempName = this.reportForm.controls.reportType.value.toLowerCase();
        const selectedCentre = this.reportForm.controls.centre.value;
        const centreId = selectedCentre.id === '-1' || selectedCentre.isGroup ? null : selectedCentre.id;
        const groupId = selectedCentre.isGroup ? selectedCentre.id : null;
        const centreName = selectedCentre.isGroup ? 'GROUP - ' + selectedCentre.name : selectedCentre.name;

        const selectedOrganisationId = !this.reportForm.controls.organisation.value ? null : this.reportForm.controls.organisation.value.id;
        const selectedOrganisationName = !this.reportForm.controls.organisation.value ? null
          : this.reportForm.controls.organisation.value.name;
        const practitionerId = !this.reportForm.controls.practitioners.value ? null : this.reportForm.controls.practitioners.value.id;
        const practitionerName = !this.reportForm.controls.practitioners.value ? null : this.reportForm.controls.practitioners.value.name;
        const occupationId = !this.reportForm.controls.occupations.value ? null : this.reportForm.controls.occupations.value.id;
        const occupationName = !this.reportForm.controls.occupations.value ? null : this.reportForm.controls.occupations.value.name;
        const vaccineId = !this.reportForm.controls.vaccine.value ? null : this.reportForm.controls.vaccine.value.id;
        const vaccineName = !this.reportForm.controls.vaccine.value ? null : this.reportForm.controls.vaccine.value.name;

        switch (tempName) {
          case this.rpTypeConst.PaymentsReceived.id:
            params = {
              [AppConstants.reportParameter.selectedClinicId]: centreId,
              [AppConstants.reportParameter.groupId]: groupId,
              [AppConstants.reportParameter.selectedClinicName]: centreName,
              [AppConstants.reportParameter.startDate]: fromDate,
              [AppConstants.reportParameter.endDate]: toDate,
              [AppConstants.reportParameter.InvoiceNo]: null,
              // type 0: Organisation, 1: Patient
              [AppConstants.reportParameter.selectedOrganisationId]: this.reportForm.controls.type.value == 0
                ? selectedOrganisationId : null,
              [AppConstants.reportParameter.selectedOrganisationName]: this.reportForm.controls.type.value == 0
                ? selectedOrganisationName : null,
              [AppConstants.reportParameter.selectedPatient]: this.reportForm.controls.type.value != 0
                ? this.reportForm.controls.patientRef.value : null,
              [AppConstants.reportParameter.currency]: this.reportForm.controls.currency.value,
              [AppConstants.reportParameter.selectedInvoices]: null
            };
            break;
          case this.rpTypeConst.AssociateClinic.id: case this.rpTypeConst.BadDebt.id:
            params = {
              [AppConstants.reportParameter.selectedClinicId]: centreId,
              [AppConstants.reportParameter.groupId]: groupId,
              [AppConstants.reportParameter.selectedClinicName]: centreName,
              [AppConstants.reportParameter.startDate]: fromDate,
              [AppConstants.reportParameter.endDate]: toDate,
              [AppConstants.reportParameter.currency]: this.reportForm.controls.currency.value
            };
            break;
          case this.rpTypeConst.EOD.id: case this.rpTypeConst.Debtors.id:
          case this.rpTypeConst.DebtorsGroupedByCentre.id:
          case this.rpTypeConst.IndividualAccounts.id: case this.rpTypeConst.PatientNumbers.id:
          case this.rpTypeConst.SalesAnalysis.id: case this.rpTypeConst.VaccinePriceList.id:
            params = {
              [AppConstants.reportParameter.selectedClinicId]: centreId,
              [AppConstants.reportParameter.groupId]: groupId,
              [AppConstants.reportParameter.selectedClinicName]: centreName,
              [AppConstants.reportParameter.startDate]: fromDate,
              [AppConstants.reportParameter.endDate]: toDate,
              [AppConstants.reportParameter.currency]: this.reportForm.controls.currency.value,
              [AppConstants.reportParameter.groupByCentre]: tempName === this.rpTypeConst.DebtorsGroupedByCentre.id
            };
            break;
          case this.rpTypeConst.CompanySales.id: case this.rpTypeConst.WithholdingTax.id: case this.rpTypeConst.Statement.id:
            params = {
              [AppConstants.reportParameter.selectedClinicId]: centreId,
              [AppConstants.reportParameter.groupId]: groupId,
              [AppConstants.reportParameter.selectedClinicName]: centreName,
              [AppConstants.reportParameter.startDate]: fromDate,
              [AppConstants.reportParameter.endDate]: toDate,
              [AppConstants.reportParameter.currency]: this.reportForm.controls.currency.value,
              [AppConstants.reportParameter.selectedOrganisationId]: selectedOrganisationId,
              [AppConstants.reportParameter.selectedOrganisationName]: selectedOrganisationName,
              [AppConstants.reportParameter.orgCode]: selectedOrganisationId
            };
            break;
          case this.rpTypeConst.DoctorIncomeAnalysis.id:
            params = {
              [AppConstants.reportParameter.selectedClinicId]: centreId,
              [AppConstants.reportParameter.groupId]: groupId,
              [AppConstants.reportParameter.selectedClinicName]: centreName,
              [AppConstants.reportParameter.startDate]: fromDate,
              [AppConstants.reportParameter.endDate]: toDate,
              [AppConstants.reportParameter.currency]: this.reportForm.controls.currency.value,
              [AppConstants.reportParameter.selectedOrganisationId]: selectedOrganisationId,
              [AppConstants.reportParameter.selectedOrganisationName]: selectedOrganisationName,
              [AppConstants.reportParameter.productCategoryIds]: this.reportForm.controls.productCategories.value ?
                this.reportForm.controls.productCategories.value.join() : [],
              [AppConstants.reportParameter.includeVaccine]: this.reportForm.controls.includeVaccineIncome.value,
              [AppConstants.reportParameter.includeConsultation]: this.reportForm.controls.includeConsultationIncome.value,
              [AppConstants.reportParameter.practitionerId]: practitionerId,
              [AppConstants.reportParameter.practitionerName]: practitionerName
              // Product Categories : this.reportForm.controls.productCategories.value
            };
            break;
          case this.rpTypeConst.TopDestinations.id:
            params = {
              [AppConstants.reportParameter.selectedClinicId]: centreId,
              [AppConstants.reportParameter.groupId]: groupId,
              [AppConstants.reportParameter.selectedClinicName]: centreName,
              [AppConstants.reportParameter.startDate]: fromDate,
              [AppConstants.reportParameter.endDate]: toDate,
              [AppConstants.reportParameter.group]: this.reportForm.controls.group.value,
              [AppConstants.reportParameter.gender]: this.reportForm.controls.gender.value || null,
              [AppConstants.reportParameter.ageGroup]: this.reportForm.controls.ageGroup.value,
              [AppConstants.reportParameter.occupationId]: occupationId,
              [AppConstants.reportParameter.occupationName]: occupationName,
              [AppConstants.reportParameter.destinationType]: this.reportForm.controls.destination.value,
              [AppConstants.reportParameter.arrayParam]: this.reportForm.controls.destinations.value
            };
            break;
          case this.rpTypeConst.TopOccupations.id:
            params = {
              [AppConstants.reportParameter.selectedClinicId]: centreId,
              [AppConstants.reportParameter.groupId]: groupId,
              [AppConstants.reportParameter.selectedClinicName]: centreName,
              [AppConstants.reportParameter.startDate]: fromDate,
              [AppConstants.reportParameter.endDate]: toDate,
              [AppConstants.reportParameter.group]: this.reportForm.controls.group.value,
              [AppConstants.reportParameter.gender]: this.reportForm.controls.gender.value || null,
              [AppConstants.reportParameter.ageGroup]: this.reportForm.controls.ageGroup.value
            };
            break;
          case this.rpTypeConst.VaccineBatchNos.id:
            params = {
              [AppConstants.reportParameter.selectedClinicId]: centreId,
              [AppConstants.reportParameter.groupId]: groupId,
              [AppConstants.reportParameter.selectedClinicName]: centreName,
              [AppConstants.reportParameter.startDate]: fromDate,
              [AppConstants.reportParameter.endDate]: toDate,
              [AppConstants.reportParameter.group]: this.reportForm.controls.group.value,
              [AppConstants.reportParameter.patientRef]: this.reportForm.controls.patientRef.value,
              [AppConstants.reportParameter.bactchNo]: this.reportForm.controls.bactchNo.value,
              [AppConstants.reportParameter.vaccineId]: vaccineId,
              [AppConstants.reportParameter.vaccineName]: vaccineName
            };
            break;
          case this.rpTypeConst.EmployeeVaccination.id:
            params = {
              [AppConstants.reportParameter.startDate]: fromDate,
              [AppConstants.reportParameter.endDate]: toDate,
              [AppConstants.reportParameter.selectedClinicId]: centreId,
              //[AppConstants.reportParameter.selectedOrganisationId]: selectedOrganisationId,
              //[AppConstants.reportParameter.patientRef]: this.reportForm.controls.patientRef.value,

               // type 0: Organisation, 1: Patient
             [AppConstants.reportParameter.selectedOrganisationId]: this.reportForm.controls.type.value == 0 ? selectedOrganisationId : null,
             [AppConstants.reportParameter.selectedOrganisationName]: this.reportForm.controls.type.value == 0 ? selectedOrganisationName : null,
             [AppConstants.reportParameter.patientRef]: this.reportForm.controls.type.value != 0 ? this.reportForm.controls.patientRef.value : null,

             [AppConstants.reportParameter.groupId]: groupId,
            };
            break;
          default:
            break;
        }
        this.shareServices.showReport(this.reportForm.controls.reportType.value, params);
        // this.reportForm.value;
      }
    }
  }


}





// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/report/report.component.ts